import DOMPurify from "dompurify";

export default function SanitizeDiv({ content, className }) {
    const sanitizedContent = DOMPurify.sanitize(content);
    return <div className={className} dangerouslySetInnerHTML={{ __html: sanitizedContent }} />;
}
